import { DateRangeFilter } from 'types/store/projectsList';
import { formatColumnDateValue } from 'Pages/ProjectsListPage/helpers/formatters';

export const getDateRangeFilterLabel = (selected: DateRangeFilter) => {
  if (selected.min && selected.max) {
    return `${formatColumnDateValue(selected.min)} - ${formatColumnDateValue(
      selected.max
    )}`;
  }

  if (selected.min && !selected.max) {
    return `${formatColumnDateValue(selected.min)}`;
  }

  if (selected.max && !selected.min) {
    return `${formatColumnDateValue(selected.max)}`;
  }

  return '';
};
